<template>
    <div class="OOP-court" v-if="court.matches.length > 0">
        <div class="OOP-court__info">

            <h2 class="OOP-court__name">
                {{courtDisplay(court.id)}} 
            </h2>
            <div class="OOP-court__time generic-medium">
                <span v-html="ico_clock"></span>
                Starting at {{court.time}}
            </div>

        </div>

        <div class="OOP-court__matches SC-OOP" >

            <div v-for="match in court.matches">

                <score-card v-if="showMatchForType(match) && match.detail"
                            :match="match"
                            :flagPath="flagPath"
                            :key="match.id"
                            :detail="detail"
                            :data-id="match.id"
                            type="all"
                            :ticket="ticket"
                            mode="live">
                </score-card>

                <oop-match
                          v-if="showMatchForType(match) && !match.detail "
                          type="all"
                          :flagPath="flagPath"
                          :ticket="ticket"
                          :key="match.id"
                          :detail="detail"
                          :match="match"
                          :court="court">

               </oop-match>

            </div>

        </div>
    </div>
</template>

<script>
    import MatchCard from './MatchCard'
    import OOPMatch from './OOPMatch'

    export default {
        components: {
            'score-card': MatchCard,
            'oop-match': OOPMatch
        },
        props: ['flagPath', 'court', 'type', 'detail', 'ticket'],
        data(){
            return{
                ico_clock  : window.ico_clock
            }
        },
        methods: {
            courtDisplay(courtId) {

                let courts = window.court_stadium

                courts = courts.filter(function(court) {
                    return court.court_id == courtId
                })

                if ( courts.length > 0 ) {
                    return courts[0].stadium_name
                }

                return courtId

            },
            showMatchForType(match) {
                if (this.type == 'all') {
                    return true
                }

                if (match.type == this.type) {
                    return true
                }

                return false
            }
        }
    }
</script>
